export enum ModalStates {
    Initial = "review",
    Form = "travelerForm",
    Success = "success",
    Failed = "fail",
}